import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EventBrellaNav from './EventBrellaNav';
import EventBrellaFooter from './EventBrellaFooter';
import TalkToUsPopup, { TalkToUsProvider } from './TalkToUsPopup';
import '../../styles/EventBrellaMarketing.css';

const EventBrellaLayout = ({ children, calculator = false, deck = false }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#cta') {
      const el = document.getElementById('cta');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  const siteClass = [
    'eventbrella-site',
    calculator ? 'eventbrella-calculator' : '',
    deck ? 'eventbrella-deck' : '',
  ].filter(Boolean).join(' ');

  return (
    <TalkToUsProvider>
      <div className={siteClass}>
        <EventBrellaNav />
        {children}
        {!deck && <EventBrellaFooter />}
        <TalkToUsPopup />
      </div>
    </TalkToUsProvider>
  );
};

export default EventBrellaLayout;
